var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { all, call, put, select, takeEvery, takeLatest, } from "redux-saga/effects";
import logger from "../../logger";
import { showAlert } from "../../utils/alert/alert.utils";
import * as contractActionsV2 from "../contract/contract.actions";
import * as contractApiV2 from "../contract/contract.api";
import * as propertyActionsV2 from "../property/property.actions";
import * as propertyApiV2 from "../property/property.api";
import * as propertyAmenityActions from "../propertyAmenity/propertyAmenity.actions";
import * as propertyAmenityApi from "../propertyAmenity/propertyAmenity.api";
import { mapDocument } from "../utils/registrationDocument.saga.utils";
import { createFailed, createStart, createSucceeded, getCountFailed, getCountStart, getCountSucceeded, getDetailFailed, getDetailStart, getDetailSucceeded, getPagedFailed, getPagedStart, getPagedSucceeded, removeFailed, removeStart, removeSucceeded, updateFailed, updateStart, updateSucceeded, brusselsRegistrationRetryStart, brusselsRegistrationRetrySucceeded, brusselsRegistrationRetryFailed, myRentRegistrationRetryStart, myRentRegistrationRetrySucceeded, myRentRegistrationRetryFailed, } from "./rentRegistration.actions";
import * as rentRegistrationApi from "./rentRegistration.api";
import * as rentRegistrationSelectors from "./rentRegistration.selectors";
function getRegistrationStartFlow(action) {
    var _a, id, onSuccess, onFailure, response, unknownError_1, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, id = _a.id, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(rentRegistrationApi.getDetail, { id: id })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, put(getDetailSucceeded.getAction({ id: id, result: response.data }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _b.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(getDetailFailed.getAction({ id: id, error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function getRegistrationPagedStartFlow(action) {
    var _a, query, onSuccess, onFailure, response, unknownError_2, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, query = _a.query, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(rentRegistrationApi.getPaged, { query: query })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, put(getPagedSucceeded.getAction({ query: query, result: response.data }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                return [3 /*break*/, 6];
            case 4:
                unknownError_2 = _b.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(getPagedFailed.getAction({ query: query, error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function getCountRegistrationStartFlow(action) {
    var _a, query, onSuccess, onFailure, response, unknownError_3, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, query = _a.query, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(rentRegistrationApi.getCount, { query: query })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, put(getCountSucceeded.getAction({ query: query, result: response.data }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                return [3 /*break*/, 6];
            case 4:
                unknownError_3 = _b.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(getCountFailed.getAction({ query: query, error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function createStartFlow(action) {
    var _a, data, onSuccess, onFailure, _b, updatedProperty, updatedContract, updatedAmenities, registrationData_1, mappedDocuments, registrationToCreate, propertyId, restPropertyFields, propertyUpdateResult, contractId, restContractFields, contractUpdateResult, response, createdRegistration, unknownError_4, error;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, data = _a.data, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 15, , 17]);
                _b = data, updatedProperty = _b.updatedProperty, updatedContract = _b.updatedContract, updatedAmenities = _b.updatedAmenities, registrationData_1 = __rest(_b, ["updatedProperty", "updatedContract", "updatedAmenities"]);
                return [4 /*yield*/, all(registrationData_1.documents.map(function (document) {
                        return mapDocument({
                            registrationDocument: document,
                            createRegistration: registrationData_1,
                        });
                    }))];
            case 2:
                mappedDocuments = _c.sent();
                registrationToCreate = __assign(__assign({}, registrationData_1), { documents: mappedDocuments });
                if (!(updatedProperty === null || updatedProperty === void 0 ? void 0 : updatedProperty.id)) return [3 /*break*/, 5];
                propertyId = updatedProperty.id, restPropertyFields = __rest(updatedProperty, ["id"]);
                return [4 /*yield*/, call(propertyApiV2.update, {
                        id: propertyId,
                        data: restPropertyFields,
                    })];
            case 3:
                propertyUpdateResult = _c.sent();
                return [4 /*yield*/, put(propertyActionsV2.updateSucceeded.getAction({
                        id: propertyId,
                        result: propertyUpdateResult.data,
                    }))];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5:
                if (!(updatedContract === null || updatedContract === void 0 ? void 0 : updatedContract.id)) return [3 /*break*/, 8];
                contractId = updatedContract.id, restContractFields = __rest(updatedContract, ["id"]);
                return [4 /*yield*/, call(contractApiV2.update, {
                        id: contractId,
                        data: restContractFields,
                    })];
            case 6:
                contractUpdateResult = _c.sent();
                return [4 /*yield*/, put(contractActionsV2.updateSucceeded.getAction({
                        id: contractId,
                        result: contractUpdateResult.data,
                    }))];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8:
                if (!(updatedAmenities &&
                    updatedAmenities.length > 0 &&
                    registrationToCreate.propertyId)) return [3 /*break*/, 11];
                return [4 /*yield*/, call(propertyAmenityApi.upsertForProperty, registrationToCreate.propertyId, { amenities: updatedAmenities })];
            case 9:
                _c.sent();
                // Refetch amenities to update the store
                return [4 /*yield*/, put(propertyAmenityActions.getByPropertyIdStart({
                        propertyId: registrationToCreate.propertyId,
                    }))];
            case 10:
                // Refetch amenities to update the store
                _c.sent();
                _c.label = 11;
            case 11: return [4 /*yield*/, call(rentRegistrationApi.create, { data: registrationToCreate })];
            case 12:
                response = _c.sent();
                createdRegistration = response.data.data;
                return [4 /*yield*/, put(contractActionsV2.getDetailStart.getAction({
                        id: createdRegistration.contractId,
                    }))];
            case 13:
                _c.sent();
                return [4 /*yield*/, put(createSucceeded.getAction({ result: response.data }))];
            case 14:
                _c.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                return [3 /*break*/, 17];
            case 15:
                unknownError_4 = _c.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(createFailed.getAction({ error: error }))];
            case 16:
                _c.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
function updateRegistrationStartFlow(action) {
    var _a, id, data, onSuccess, onFailure, response, unknownError_5, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, id = _a.id, data = _a.data, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(rentRegistrationApi.update, { id: id, data: data })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, put(contractActionsV2.getDetailStart.getAction({
                        id: response.data.data.contractId,
                    }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, put(updateSucceeded.getAction({ id: id, result: response.data }))];
            case 4:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                return [3 /*break*/, 7];
            case 5:
                unknownError_5 = _b.sent();
                error = unknownError_5;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(updateFailed.getAction({ id: id, error: error }))];
            case 6:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function deleteRegistrationStartFlow(action) {
    var _a, id, onSuccess, onFailure, cachedRegistration, _b, _c, unknownError_6, error;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = action.payload, id = _a.id, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 7, , 9]);
                _c = (_b = rentRegistrationSelectors).getDetail;
                return [4 /*yield*/, select()];
            case 2:
                cachedRegistration = _c.apply(_b, [_d.sent(), id]);
                return [4 /*yield*/, call(rentRegistrationApi.remove, { id: id })];
            case 3:
                _d.sent();
                if (!cachedRegistration) return [3 /*break*/, 5];
                return [4 /*yield*/, put(contractActionsV2.getDetailStart.getAction({
                        id: cachedRegistration.contractId,
                    }))];
            case 4:
                _d.sent();
                _d.label = 5;
            case 5: return [4 /*yield*/, put(removeSucceeded.getAction({ id: id }))];
            case 6:
                _d.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 9];
            case 7:
                unknownError_6 = _d.sent();
                error = unknownError_6;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(removeFailed.getAction({ id: id, error: error }))];
            case 8:
                _d.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function myRentRegistrationRetryStartFlow(action) {
    var _a, registration, registrationId, updatedProperty, updatedContract, updatedAmenities, propertyId, restPropertyFields, propertyUpdateResult, contractId, restContractFields, contractUpdateResult, mappedDocuments, registrationToCreate, createdRegistration, unknownError_7, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, registration = _a.registration, registrationId = _a.registrationId, updatedProperty = _a.updatedProperty, updatedContract = _a.updatedContract, updatedAmenities = _a.updatedAmenities;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 15, , 17]);
                if (!(updatedProperty === null || updatedProperty === void 0 ? void 0 : updatedProperty.id)) return [3 /*break*/, 4];
                propertyId = updatedProperty.id, restPropertyFields = __rest(updatedProperty, ["id"]);
                return [4 /*yield*/, call(propertyApiV2.update, {
                        id: propertyId,
                        data: restPropertyFields,
                    })];
            case 2:
                propertyUpdateResult = _b.sent();
                return [4 /*yield*/, put(propertyActionsV2.updateSucceeded.getAction({
                        id: propertyId,
                        result: propertyUpdateResult.data,
                    }))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4:
                if (!(updatedContract === null || updatedContract === void 0 ? void 0 : updatedContract.id)) return [3 /*break*/, 7];
                contractId = updatedContract.id, restContractFields = __rest(updatedContract, ["id"]);
                return [4 /*yield*/, call(contractApiV2.update, {
                        id: contractId,
                        data: restContractFields,
                    })];
            case 5:
                contractUpdateResult = _b.sent();
                return [4 /*yield*/, put(contractActionsV2.updateSucceeded.getAction({
                        id: contractId,
                        result: contractUpdateResult.data,
                    }))];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7:
                if (!(updatedAmenities &&
                    updatedAmenities.length > 0 &&
                    registration.propertyId)) return [3 /*break*/, 10];
                return [4 /*yield*/, call(propertyAmenityApi.upsertForProperty, registration.propertyId, { amenities: updatedAmenities })];
            case 8:
                _b.sent();
                return [4 /*yield*/, put(propertyAmenityActions.getByPropertyIdStart({
                        propertyId: registration.propertyId,
                    }))];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [4 /*yield*/, all(registration.documents.map(function (document) {
                    return mapDocument({
                        registrationDocument: document,
                        createRegistration: registration,
                    });
                }))];
            case 11:
                mappedDocuments = _b.sent();
                registrationToCreate = __assign(__assign({}, registration), { documents: mappedDocuments });
                return [4 /*yield*/, call(rentRegistrationApi.retryMyRentRegistration, registrationId, registrationToCreate)];
            case 12:
                createdRegistration = (_b.sent()).data;
                return [4 /*yield*/, put(contractActionsV2.getDetailStart.getAction({
                        id: createdRegistration.contractId,
                    }))];
            case 13:
                _b.sent();
                return [4 /*yield*/, put(myRentRegistrationRetrySucceeded.getAction({
                        registration: createdRegistration,
                        registrationId: registrationId,
                    }))];
            case 14:
                _b.sent();
                return [3 /*break*/, 17];
            case 15:
                unknownError_7 = _b.sent();
                error = unknownError_7;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(myRentRegistrationRetryFailed.getAction({
                        registrationId: registrationId,
                        error: error,
                    }))];
            case 16:
                _b.sent();
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
function brusselsRegistrationRetryStartFlow(action) {
    var _a, registrationId, updatedProperty, updatedContract, updatedAmenities, onSuccess, propertyId, restPropertyFields, propertyUpdateResult, contractId, restContractFields, contractUpdateResult, registrationResponse, unknownError_8, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, registrationId = _a.registrationId, updatedProperty = _a.updatedProperty, updatedContract = _a.updatedContract, updatedAmenities = _a.updatedAmenities, onSuccess = _a.onSuccess;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 14, , 16]);
                if (!(updatedProperty === null || updatedProperty === void 0 ? void 0 : updatedProperty.id)) return [3 /*break*/, 4];
                propertyId = updatedProperty.id, restPropertyFields = __rest(updatedProperty, ["id"]);
                return [4 /*yield*/, call(propertyApiV2.update, {
                        id: propertyId,
                        data: restPropertyFields,
                    })];
            case 2:
                propertyUpdateResult = _b.sent();
                return [4 /*yield*/, put(propertyActionsV2.updateSucceeded.getAction({
                        id: propertyId,
                        result: propertyUpdateResult.data,
                    }))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4:
                if (!(updatedContract === null || updatedContract === void 0 ? void 0 : updatedContract.id)) return [3 /*break*/, 7];
                contractId = updatedContract.id, restContractFields = __rest(updatedContract, ["id"]);
                return [4 /*yield*/, call(contractApiV2.update, {
                        id: contractId,
                        data: restContractFields,
                    })];
            case 5:
                contractUpdateResult = _b.sent();
                return [4 /*yield*/, put(contractActionsV2.updateSucceeded.getAction({
                        id: contractId,
                        result: contractUpdateResult.data,
                    }))];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7:
                if (!(updatedAmenities &&
                    updatedAmenities.length > 0 &&
                    (updatedProperty === null || updatedProperty === void 0 ? void 0 : updatedProperty.id))) return [3 /*break*/, 10];
                return [4 /*yield*/, call(propertyAmenityApi.upsertForProperty, updatedProperty.id, {
                        amenities: updatedAmenities,
                    })];
            case 8:
                _b.sent();
                return [4 /*yield*/, put(propertyAmenityActions.getByPropertyIdStart({
                        propertyId: updatedProperty.id,
                    }))];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [4 /*yield*/, call(rentRegistrationApi.retryBrusselsRegistration, registrationId)];
            case 11:
                _b.sent();
                return [4 /*yield*/, call(rentRegistrationApi.getDetail, { id: registrationId })];
            case 12:
                registrationResponse = _b.sent();
                return [4 /*yield*/, put(brusselsRegistrationRetrySucceeded.getAction({
                        registrationId: registrationId,
                        registration: registrationResponse.data.data,
                    }))];
            case 13:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(registrationId);
                return [3 /*break*/, 16];
            case 14:
                unknownError_8 = _b.sent();
                error = unknownError_8;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(brusselsRegistrationRetryFailed.getAction({
                        registrationId: registrationId,
                        error: error,
                    }))];
            case 15:
                _b.sent();
                return [3 /*break*/, 16];
            case 16: return [2 /*return*/];
        }
    });
}
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(createStart.type, createStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(getDetailStart.type, getRegistrationStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(getPagedStart.type, getRegistrationPagedStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(getCountStart.type, getCountRegistrationStartFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(updateStart.type, updateRegistrationStartFlow)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(removeStart.type, deleteRegistrationStartFlow)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeLatest(myRentRegistrationRetryStart.type, myRentRegistrationRetryStartFlow)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeLatest(brusselsRegistrationRetryStart.type, brusselsRegistrationRetryStartFlow)];
            case 8:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
